<template>
  <v-card>
    <v-card-text>
      <form data-vv-scope="stockDescForm">
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.stkType }}</v-subheader>
              <div class="queryValue">{{ stockDescQueryForm.stkType }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-text-field
                :label="labels.stkType"
                v-model="stockDescForm.stkType"
                :error-messages="errors.collect('stockDescForm.stkType')"
                data-vv-name="stockDescForm.stkType"
                :data-vv-as="labels.stkType"
                append-icon="mdi-magnify"
                @click:append="getHelpList()"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.stkVal }}</v-subheader>
              <div class="queryValue">{{ stockDescForm.stkVal }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-text-field
                :label="labels.stkVal"
                v-model="stockDescForm.stkVal"
                :error-messages="errors.collect('stockDescForm.stkVal')"
                data-vv-name="stockDescForm.stkVal"
                :data-vv-as="labels.stkVal"
                v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
                v-validate="'mask_decimal:2|mask_max_value:999999999999999999.99'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.highVal }}</v-subheader>
              <div class="queryValue">{{ stockDescForm.highVal }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-text-field
                :label="labels.highVal"
                v-model="stockDescForm.highVal"
                :error-messages="errors.collect('stockDescForm.highVal')"
                data-vv-name="stockDescForm.highVal"
                :data-vv-as="labels.highVal"
                v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
                v-validate="'mask_decimal:2|mask_max_value:999999999999999999.99'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.invRec }}</v-subheader>
              <div class="queryValue">{{ stockDescForm.invRec }}</div>
            </v-flex>
            <v-flex xs12 v-else>
              <v-text-field
                :label="labels.invRec"
                v-model="stockDescForm.invRec"
                :error-messages="errors.collect('stockDescForm.invRec')"
                data-vv-name="stockDescForm.invRec"
                :data-vv-as="labels.invRec"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>

    <v-dialog v-model="showCargoComdtyHelpList" width="1280px">
      <cargo-comdty-help-list
        :title="dialogTitle"
        @close="showCargoComdtyHelpList = false"
        @assign-cargo-comdty-val-info="assignValue"
      ></cargo-comdty-help-list>
    </v-dialog>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { formatPrice } from '@/utils/index'
import { expandURI } from '@/utils/ajax'
import CargoComdtyHelpList from '@/components/core/common/dialog/CargoComdtyHelpList'

export default {
  data() {
    return {
      labels: {
        stkType: 'Type of Stock',
        stkVal: 'Total Value of Stock',
        highVal: 'Highest Value / Article',
        invRec: 'Inventory Record'
      },
      stockDescForm: {
        survNo: undefined,
        verCnt: undefined,
        stkType: undefined,
        stkVal: 0,
        highVal: 0,
        invRec: undefined,
        survDetType: 'stockDescription'
      },
      stockDescQueryForm: {
        stkType: undefined
      },
      actionLabel: {
        exit: 'Exit',
        save: 'Save',
        reset: 'Reset'
      },
      validStatus: {
        mandatory: true,
        optional: true
      },
      loading: false,
      showErrorDialog: false,
      submitting: false,
      showCargoComdtyHelpList: false,
      dialogTitle: undefined
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    riskSurveyMenu() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveySettings.menu
    },
    riskSurveyMaster() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMaster
    },
    riskSurveyDetails() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyDetails
    },
    riskSurveyMode() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMode
    }
  },
  methods: {
    async doInit() {
      this.stockDescForm.survNo = this.riskSurveyMaster.survNo
      this.stockDescForm.verCnt = this.riskSurveyMaster.verCnt
      this.loadInit()
    },
    loadInit() {
      this.stockDescForm.stkType = this.riskSurveyDetails.stkType
      this.stockDescForm.stkVal = formatPrice(this.riskSurveyDetails.stkVal)
      this.stockDescForm.highVal = formatPrice(this.riskSurveyDetails.highVal)
      this.stockDescForm.invRec = this.riskSurveyDetails.invRec

      if (this.riskSurveyMode === 'Query') {
        this.doGetCrgoComdty(this.riskSurveyDetails.stkType)
      }
    },
    async doGetCrgoComdty(data) {
      const apiURI = this.riskSurveyMenu.getCrgoComdty
      if (apiURI) {
        const expand = {
          crgoComdty: data
        }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              this.stockDescQueryForm.stkType = data
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    getHelpList() {
      this.dialogTitle = 'Type of Goods'
      this.showCargoComdtyHelpList = true
    },
    assignValue(data) {
      this.stockDescForm.stkType = data.comdty
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    doReset() {
      this.stockDescForm.stkType = undefined
      this.stockDescForm.stkVal = 0
      this.stockDescForm.highVal = 0
      this.stockDescForm.invRec = undefined
    },
    formatPrice(data) {
      return formatPrice(data)
    }
  },
  created() {},
  mounted() {
    this.doInit()
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.$store.dispatch('riskSurveyInit').then(() => {
          this.doInit()
        })
      })
    } else {
      this.$store.dispatch('riskSurveyInit').then(() => {
        this.doInit()
      })
    }
  },
  mixins: [MessageMixin],
  components: {
    CargoComdtyHelpList
  }
}
</script>
<style lang="scss">
@import '../../../../../assets/scss/accounting.scss';
</style>
